"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 11.857V16H7v-4.143L1 13l3.885-4.44L3 9l3.07-4.297L5 5l3-5 3 5-1.07-.297L13 9l-1.885-.44L15 13l-6-1.143z"];
//# sourceMappingURL=tree.js.map